import { createFileRoute } from "@tanstack/react-router"

import { adminAccountsSearchSchema } from "@/features/admin/admin-search-schema"
import { AdminAccountsPage } from "@/pages/admin/accounts"

export const Route = createFileRoute("/_authenticated/admin/")({
  validateSearch: (search) => adminAccountsSearchSchema.parse(search),
  component: AdminAccountsPage,
})
